"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledLabel = exports.StyledCheckboxButton = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _button = require("../../../styles/2_commonComponentStyles/button");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledCheckboxButton = _styledComponents.default.button.withConfig({
  displayName: "CheckboxButtonstyles__StyledCheckboxButton",
  componentId: "olx3wj-0"
})(["", ";", ";"], _button.clickable, _button.checkableButton);

exports.StyledCheckboxButton = StyledCheckboxButton;

var StyledLabel = _styledComponents.default.div.withConfig({
  displayName: "CheckboxButtonstyles__StyledLabel",
  componentId: "olx3wj-1"
})(["flex:1 1 100%;background:inherit;color:inherit;font:inherit;margin-left:.5rem;"]);

exports.StyledLabel = StyledLabel;